import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "../../utils/axios";
// utils

// ----------------------------------------------------------------------

const initialState = {
  isLoading: false,
  fetchLoading: false,
  booking: {
    data: [],
    meta: {
      total: 0,
    },
  },
};

// TODO: fetch all the booking
export const fetchBooking = createAsyncThunk(
  "fetchBooking/booking",
  async (
    { enqueueSnackbar, limit = 10, page = 0, search, filter, status },
    thunkApi
  ) => {
    try {
      const response = await axiosInstance.get(`booking`, {
        params: {
          ...(search !== "" && {
            search,
            ...(filter && { filter: filter }),
            ...(status && { status: status }),
          }),
          limit,
          page: page + 1,
        },
      });

      return {
        data: response.data.data,
        meta: {
          total: response.data.total,
        },
      };
    } catch (error) {
      return thunkApi.rejectWithValue({ error, enqueueSnackbar });
    }
  }
);

// TODO: create the booking
export const createBooking = createAsyncThunk(
  "createBooking/booking",
  async ({ enqueueSnackbar, data, handleClose }, thunkApi) => {
    try {
      const response = await axiosInstance.post(`booking`, data);
      return {
        data: response.data.data,
        meta: {
          total: response.data.data.length,
        },
        handleClose,
        enqueueSnackbar,
      };
    } catch (error) {
      return thunkApi.rejectWithValue({ error, enqueueSnackbar });
    }
  }
);

// TODO: update the booking
export const updateBooking = createAsyncThunk(
  "updateBooking/booking",
  async ({ enqueueSnackbar, data, handleClose, id }, thunkApi) => {
    try {
      const response = await axiosInstance.patch(`booking/${id}`, data);
      return {
        data: response.data.data,
        handleClose,
        enqueueSnackbar,
      };
    } catch (error) {
      return thunkApi.rejectWithValue({ error, enqueueSnackbar });
    }
  }
);

// TODO: delete booking
export const deleteBooking = createAsyncThunk(
  "deleteBooking/booking",
  async ({ enqueueSnackbar, handleClose, id }, thunkApi) => {
    try {
      await axiosInstance.delete(`booking/${id}`);
      return {
        data: id,
        handleClose,
        enqueueSnackbar,
      };
    } catch (error) {
      return thunkApi.rejectWithValue({ error, enqueueSnackbar });
    }
  }
);

const bookinglice = createSlice({
  name: "booking",
  initialState,
  extraReducers: (builder) => {
    // TODO: fetch booking
    builder.addCase(fetchBooking.pending, (state, _) => {
      state.fetchLoading = true;
    });

    builder.addCase(fetchBooking.fulfilled, (state, action) => {
      state.fetchLoading = false;
      state.booking = action.payload;
    });

    builder.addCase(fetchBooking.rejected, (state, action) => {
      state.fetchLoading = false;
      state.isLoading = false;
      action.payload.enqueueSnackbar(action.payload.error.message, {
        variant: "error",
      });
    });

    // TODO: create booking
    builder.addCase(createBooking.pending, (state, _) => {
      state.isLoading = true;
    });

    builder.addCase(createBooking.fulfilled, (state, action) => {
      state.isLoading = false;
      state.booking.data = [action.payload.data, ...state.booking.data];
      state.booking.meta.total = state.booking.meta.total + 1;
      action.payload.enqueueSnackbar("Booking is created successfully.", {
        variant: "success",
      });
      action.payload.handleClose && action.payload.handleClose();
    });

    builder.addCase(createBooking.rejected, (state, action) => {
      state.isLoading = false;
      action.payload.enqueueSnackbar(action.payload.error.message, {
        variant: "error",
      });
    });

    // TODO: update booking
    builder.addCase(updateBooking.pending, (state, _) => {
      state.isLoading = true;
    });

    builder.addCase(updateBooking.fulfilled, (state, action) => {
      state.isLoading = false;
      state.booking.data = state.booking.data.map((booking) => {
        if (booking.id === action.payload.data.id) {
          return action.payload.data;
        } else {
          return booking;
        }
      });
      action.payload.enqueueSnackbar("Booking is updated successfully.", {
        variant: "success",
      });
      action.payload.handleClose && action.payload.handleClose();
    });

    builder.addCase(updateBooking.rejected, (state, action) => {
      state.isLoading = false;
      action.payload.enqueueSnackbar(action.payload.error.message, {
        variant: "error",
      });
    });

    // TODO: delete booking
    builder.addCase(deleteBooking.pending, (state, _) => {
      state.isLoading = true;
    });

    builder.addCase(deleteBooking.fulfilled, (state, action) => {
      state.isLoading = false;
      state.booking.data = state.booking.data.filter(
        (booking) => booking.id !== action.payload.data
      );
      state.booking.meta.total = state.booking.meta.total - 1;
      action.payload.enqueueSnackbar("Booking is deleted successfully.", {
        variant: "success",
      });
      action.payload.handleClose && action.payload.handleClose();
    });

    builder.addCase(deleteBooking.rejected, (state, action) => {
      state.isLoading = false;
      action.payload.enqueueSnackbar(action.payload.error.message, {
        variant: "error",
      });
    });
  },
});

export default bookinglice.reducer;
